<template>
    <div class="page">
        <div class="top-header" :class="{ active: this.myScore <= 0 }">
            <div class="scoreBox">
                <span class="score">{{ score }}</span>
                <span class="unit">分</span>
            </div>
            <div class="scoreIntro">{{ huashu }}</div>
            <div class="starBox">
                <img
                    v-for="(item, index) in 5"
                    :key="index"
                    @click="changeScore(item)"
                    class="star"
                    :src="item <= score ? StarActive : Star"
                />
            </div>
        </div>
        <textarea
            v-iosInput
            class="content"
            v-model="content"
            placeholder="快来写下你的感受吧～"
        ></textarea>
        <div class="btn" @click="submit()">发布</div>
    </div>
</template>

<script>
import Star from "../../assets/star.png";
import StarActive from "../../assets/star-active.png";
import commentService from "../../service/comment.service";
import { Toast } from "vant";
export default {
    name: "comment",
    data() {
        return {
            score: 0,
            Star,
            StarActive,
            content: "",
            parentId: "",
            classify: "STUDY_EPISODE",
            clssifyforId: "",
            scoreConfig: [],
            huashu: "",
            myScore: 5,
            loading: false
        };
    },
    methods: {
        changeScore(index) {
            if (this.myScore) {
                return;
            }
            this.score = index;
            this.scoreConfig.forEach(item => {
                if (item.score == this.score) {
                    this.huashu = item.huashu;
                }
            });
        },
        submit() {
            if (this.content.length <= 0) {
                Toast("评论内容不能为空");
                return;
            }
            if (this.loading) {
                Toast("提交中。。。");
                return;
            }
            this.loading = true;
            commentService
                .submit({
                    score: this.score,
                    content: this.content,
                    classify: this.classify,
                    parentId: this.parentId,
                    clssifyforId: this.clssifyforId
                })
                .then(() => {
                    this.loading = false;
                    Toast({
                        message: "评论成功,等待审核",
                        onClose: () => {
                            this.$router.back();
                        }
                    });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getMySumbitScore() {
            commentService
                .getMySumbitScore({ episodeId: this.clssifyforId })
                .then(res => {
                    this.score = this.myScore = res.data.score || 0;
                    this.changeScore(this.myScore);
                });
        },
        getScoreConfig() {
            commentService.getScoreConfig().then(res => {
                this.scoreConfig = res.data;
                this.getMySumbitScore();
            });
        }
    },
    mounted() {
        this.clssifyforId = this.$route.params.clssifyforId;
        this.parentId = this.$route.query.parentId;
        this.getScoreConfig();
    }
};
</script>

<style lang="scss" scoped src="./comment.scss">
</style>

